import { CSSProperties } from 'react';
import { ComputedCaptionsStyles, Page } from '@/player-config/src/types/remotion-types';

/**
 * WebkitTextStroke renders below shadows (text -> shadow -> stroke), which produces poor visual results.
 * This implementation uses shadows to simulate stroke effects, enabling proper layering (text -> stroke -> shadow).
 */
function getShadowBasedStroke(
  webkitTextStrokeWidth: CSSProperties['WebkitTextStrokeWidth'],
  webkitTextStrokeColor: CSSProperties['WebkitTextStrokeColor']
): CSSProperties['textShadow'] {
  const shadows: string[] = [];

  if (webkitTextStrokeWidth && webkitTextStrokeColor) {
    const strokeWidth = parseFloat(webkitTextStrokeWidth.toString().replace('px', ''));
    const strokeColor = webkitTextStrokeColor;

    for (let x = -strokeWidth; x <= strokeWidth; x++) {
      for (let y = -strokeWidth; y <= strokeWidth; y++) {
        if (x !== 0 || y !== 0) {
          shadows.push(`${x}px ${y}px 0 ${strokeColor}`);
        }
      }
    }
  }

  return shadows.join(', ');
}

function getComputedGroupedTokensStyle(page: Page): ComputedCaptionsStyles['groupedTokensStyle'] {
  const style = { ...page.groupedTokensStyle };

  const shadowBasedStroke = getShadowBasedStroke(
    page.groupedTokensStyle.WebkitTextStrokeWidth,
    page.groupedTokensStyle.WebkitTextStrokeColor
  );

  if (shadowBasedStroke) {
    delete style.WebkitTextStrokeWidth;
    delete style.WebkitTextStrokeColor;
    delete style.paintOrder;
  }

  const existingTextShadow = page.groupedTokensStyle.textShadow;
  const finalTextShadow =
    shadowBasedStroke && existingTextShadow
      ? `${shadowBasedStroke}, ${existingTextShadow}`
      : shadowBasedStroke || existingTextShadow || '';

  return {
    ...style,
    textShadow: finalTextShadow
  };
}

export function getComputedCaptionsStyles(page: Page): ComputedCaptionsStyles {
  return {
    groupedTokensStyle: getComputedGroupedTokensStyle(page)
  };
}
